// Banks whose own app only understands the old NBU IBAN QR format (version 002).
// Remove an entry (or this whole file) once that bank's app supports version 003.
export default {
  ios: ['izibank', 'globus', 'radabank'],
  android: ['ukrgasbank'],
};
